import React from 'react';
import {
  SerifHeading,
  SectionLabel,
  HSecondaryButton,
  HDestructiveButton,
  HButtonPair,
} from '../h';

/* v9 mockup 4.6 — Factory reset confirmation dialog.

   Renders as a modal overlay (centered card on dimmed backdrop). The
   confirmation copy reflects what `signoutRequested = true` actually does:
     - the device returns to the setup screen (TVApp listens and signs out)
     - WiFi and account binding are cleared
     - the family record (and its Higlo memberships, names, preferences)
       is preserved, so re-setup re-attaches the existing family.
*/
export function FactoryResetDialog({ onCancel, onConfirm, isWorking }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-md bg-white rounded-2xl shadow-xl ring-1 ring-slate-200 p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center mb-3">
          <div className="w-12 h-12 rounded-full flex items-center justify-center bg-red-50">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#dc2626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
        </div>
        <SerifHeading size="md" className="text-center mb-2">
          Factory reset this Hearth?
        </SerifHeading>
        <p className="text-[13px] text-slate-600 mb-3 text-center max-w-[320px] mx-auto">
          Sends the device back to step one. Its place in any Higlos is preserved — it&rsquo;ll rejoin once set up again.
        </p>
        <div className="bg-slate-50 rounded-xl border border-slate-200 p-3 mb-4">
          <SectionLabel className="mb-1.5">This will…</SectionLabel>
          <ul className="text-[12px] text-slate-700 space-y-0.5">
            <li className="flex items-start gap-1.5">
              <span className="text-slate-400">•</span>
              <span>Sign out the Hearth and return it to the setup screen</span>
            </li>
            <li className="flex items-start gap-1.5">
              <span className="text-slate-400">•</span>
              <span>Remove its WiFi details</span>
            </li>
            <li className="flex items-start gap-1.5">
              <span className="text-slate-400">•</span>
              <span>Keep its name, preferences, and Higlo memberships</span>
            </li>
          </ul>
        </div>
        <HButtonPair>
          <HSecondaryButton onClick={onCancel} disabled={isWorking}>
            Cancel
          </HSecondaryButton>
          <HDestructiveButton onClick={onConfirm} disabled={isWorking}>
            {isWorking ? 'Resetting…' : 'Reset'}
          </HDestructiveButton>
        </HButtonPair>
      </div>
    </div>
  );
}
